// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dkXH","right":"styles_right__33Aox"};